import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as actions from '../service.actions';
import { contactSendMessageAction } from '../service.actions';
import { from, of } from 'rxjs';
import { RootState } from '../..';
import { ContactRestService } from '../../../services/rest/contact.rest.service';
import { AbstractEffects } from '../../AbstractEffects';
import { TranslateService } from '@ngx-translate/core';
import { AzureMonitoringService } from '../../../services/AzureMonitoringService';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class ContactEffects extends AbstractEffects {
  sendContactMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(contactSendMessageAction),
      mergeMap(
        (
          action // Register to this event, unregister previous if new event occurs.
        ) =>
          this.contactRestService
            .sendContactMessage(action.message) // Send contact message
            .pipe(
              switchMap(() => {
                this.notificationService.showModal({
                  type: 'success',
                  messageCode: 'SERVICE.CONTACT.SEND_SUCCESS',
                  disableClose: false,
                });
                return from([
                  actions.contactSendMessageSuccessAction(),
                ]);
              }),
              catchError(err => this.handleFail(err, 'ERRORS.FILTER_FAILED.TITLE', [of(actions.contactSendMessageFailAction(err))]))
            )
      )
    )
  );

  constructor(
    private store: Store<RootState>,
    azureMonitoringService: AzureMonitoringService,
    private actions$: Actions,
    private contactRestService: ContactRestService,
    translateService: TranslateService,
    notificationService: NotificationService
  ) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
